var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2261F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.9062C9.49177 14.9062 9.89043 14.5173 9.89043 14.0377C9.89043 13.558 9.49177 13.1692 9 13.1692C8.50822 13.1692 8.10956 13.558 8.10956 14.0377C8.10956 14.5173 8.50822 14.9062 9 14.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.83075C9.49177 4.83075 9.89043 4.44191 9.89043 3.96225C9.89043 3.48259 9.49177 3.09375 9 3.09375C8.50822 3.09375 8.10956 3.48259 8.10956 3.96225C8.10956 4.44191 8.50822 4.83075 9 4.83075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 7.20505C9.39365 7.20505 9.71273 6.89403 9.71273 6.51036C9.71273 6.1267 9.39365 5.81567 9.00004 5.81567C8.60643 5.81567 8.28735 6.1267 8.28735 6.51036C8.28735 6.89403 8.60643 7.20505 9.00004 7.20505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50645 5.93088C6.90006 5.93088 7.21914 5.61986 7.21914 5.23619C7.21914 4.85253 6.90006 4.5415 6.50645 4.5415C6.11284 4.5415 5.79376 4.85253 5.79376 5.23619C5.79376 5.61986 6.11284 5.93088 6.50645 5.93088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50645 13.5163C6.90006 13.5163 7.21914 13.2053 7.21914 12.8216C7.21914 12.438 6.90006 12.127 6.50645 12.127C6.11284 12.127 5.79376 12.438 5.79376 12.8216C5.79376 13.2053 6.11284 13.5163 6.50645 13.5163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2264 8.50778C11.62 8.50778 11.9391 8.19676 11.9391 7.8131C11.9391 7.42943 11.62 7.11841 11.2264 7.11841C10.8328 7.11841 10.5137 7.42943 10.5137 7.8131C10.5137 8.19676 10.8328 8.50778 11.2264 8.50778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2264 10.9109C11.62 10.9109 11.9391 10.5998 11.9391 10.2162C11.9391 9.83251 11.62 9.52148 11.2264 9.52148C10.8328 9.52148 10.5137 9.83251 10.5137 10.2162C10.5137 10.5998 10.8328 10.9109 11.2264 10.9109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 12.1848C9.39365 12.1848 9.71273 11.8738 9.71273 11.4901C9.71273 11.1064 9.39365 10.7954 9.00004 10.7954C8.60643 10.7954 8.28735 11.1064 8.28735 11.4901C8.28735 11.8738 8.60643 12.1848 9.00004 12.1848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 9.5625C9.31163 9.5625 9.56423 9.31066 9.56423 9C9.56423 8.68934 9.31163 8.4375 9.00004 8.4375C8.68845 8.4375 8.43585 8.68934 8.43585 9C8.43585 9.31066 8.68845 9.5625 9.00004 9.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50645 10.8074C6.81804 10.8074 7.07064 10.5555 7.07064 10.2449C7.07064 9.93421 6.81804 9.68237 6.50645 9.68237C6.19486 9.68237 5.94226 9.93421 5.94226 10.2449C5.94226 10.5555 6.19486 10.8074 6.50645 10.8074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50645 8.37573C6.81804 8.37573 7.07064 8.12389 7.07064 7.81323C7.07064 7.50257 6.81804 7.25073 6.50645 7.25073C6.19486 7.25073 5.94226 7.50257 5.94226 7.81323C5.94226 8.12389 6.19486 8.37573 6.50645 8.37573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07196 7.07275C4.38262 7.07275 4.63446 6.82091 4.63446 6.51025C4.63446 6.19959 4.38262 5.94775 4.07196 5.94775C3.7613 5.94775 3.50946 6.19959 3.50946 6.51025C3.50946 6.82091 3.7613 7.07275 4.07196 7.07275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07196 9.5625C4.38262 9.5625 4.63446 9.31066 4.63446 9C4.63446 8.68934 4.38262 8.4375 4.07196 8.4375C3.7613 8.4375 3.50946 8.68934 3.50946 9C3.50946 9.31066 3.7613 9.5625 4.07196 9.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07196 12.0522C4.38262 12.0522 4.63446 11.8004 4.63446 11.4897C4.63446 11.1791 4.38262 10.9272 4.07196 10.9272C3.7613 10.9272 3.50946 11.1791 3.50946 11.4897C3.50946 11.8004 3.7613 12.0522 4.07196 12.0522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2264 6.10492C11.7182 6.10492 12.1168 5.71608 12.1168 5.23642C12.1168 4.75676 11.7182 4.36792 11.2264 4.36792C10.7346 4.36792 10.3359 4.75676 10.3359 5.23642C10.3359 5.71608 10.7346 6.10492 11.2264 6.10492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2264 13.6613C11.7182 13.6613 12.1168 13.2725 12.1168 12.7928C12.1168 12.3132 11.7182 11.9243 11.2264 11.9243C10.7346 11.9243 10.3359 12.3132 10.3359 12.7928C10.3359 13.2725 10.7346 13.6613 11.2264 13.6613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4534 7.37836C13.9451 7.37836 14.3438 6.98952 14.3438 6.50986C14.3438 6.0302 13.9451 5.64136 13.4534 5.64136C12.9616 5.64136 12.5629 6.0302 12.5629 6.50986C12.5629 6.98952 12.9616 7.37836 13.4534 7.37836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4534 12.3586C13.9451 12.3586 14.3438 11.9697 14.3438 11.4901C14.3438 11.0104 13.9451 10.6216 13.4534 10.6216C12.9616 10.6216 12.5629 11.0104 12.5629 11.4901C12.5629 11.9697 12.9616 12.3586 13.4534 12.3586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4534 9.86859C13.9451 9.86859 14.3438 9.47975 14.3438 9.00009C14.3438 8.52043 13.9451 8.13159 13.4534 8.13159C12.9616 8.13159 12.5629 8.52043 12.5629 9.00009C12.5629 9.47975 12.9616 9.86859 13.4534 9.86859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxy);
export default __webpack_public_path__ + "static/media/oxy.6d1205b25a62e8b5af53c88ec82a81fc.svg";
export { ForwardRef as ReactComponent };